import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import get from '../utils/get';
import { SUGGEST_SEARCH, SUGGEST_SEARCH_SUCCESS, SUGGEST_SEARCH_LOADING, SUGGEST_SET_ITEM, SUGGEST_RESET, SUGGEST_SEARCH_VIA_BACKEND, SUGGEST_SET_ITEMS } from '../actions/constants';
var initialState = {
  items: [],
  query: '',
  isLoading: false,
  error: null
};

var suggestionsReducer = function suggestionsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SUGGEST_SEARCH:
    case SUGGEST_SEARCH_VIA_BACKEND:
      return _objectSpread(_objectSpread({}, state), {}, {
        query: action.payload.query
      });

    case SUGGEST_SEARCH_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: true
      });

    case SUGGEST_SEARCH_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        isLoading: false,
        items: action.payload.map(function (item) {
          var name = item.name,
              firstName = item.firstName,
              lastName = item.lastName;
          return _objectSpread(_objectSpread({}, item), {}, {
            label: "".concat(name || "".concat(firstName, " ").concat(lastName)),
            id: item.objectID
          });
        })
      });

    case SUGGEST_SET_ITEM:
      // eslint-disable-next-line no-case-declarations
      var objectType = get(action, 'payload.item.objectType'); // eslint-disable-next-line no-case-declarations

      var existingItem = ['speciality', 'expertise'].includes(objectType) ? state.items.find(function (_ref) {
        var shortName = _ref.shortName;
        return shortName === get(action, 'payload.item.shortName');
      }) : state.items.find(function (_ref2) {
        var id = _ref2.id;
        return id === get(action, 'payload.item.id');
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        item: existingItem ? _objectSpread({}, existingItem) : get(action, 'payload.item')
      });

    case SUGGEST_SET_ITEMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        items: _toConsumableArray(action.payload.items)
      });

    case SUGGEST_RESET:
      return _objectSpread({}, initialState);

    default:
      return state;
  }
};

export default suggestionsReducer;
//# sourceMappingURL=suggestions.js.map